/* eslint-disable no-control-regex */
/**
 * Utility functions to sanitize, repair, and format LaTeX strings across the application.
 * Fixes JSON escape corruption (e.g. \t turning into tab + ext, \f turning into form feed + rac)
 * and ensures KaTeX renders clean mathematical and textual notations.
 */

export function repairLatexEscapes(str) {
  if (!str || typeof str !== "string") return "";
  let s = str;

  // 1. Repair control characters that were collapsed by JSON.parse
  s = s.replace(/\x09(ext[a-z]*|au|heta|imes|o|an|op|riangle|ilde)\b/g, "\\t$1");
  s = s.replace(/\x0c(rac|lat|orall)\b/g, "\\f$1");
  s = s.replace(/\x08(extbf|eta|ar|egin|ig|ullet|inom|matrix)\b/g, "\\b$1");
  s = s.replace(/\x0d(ight|ho|m)\b/g, "\\r$1");
  s = s.replace(/\n(eq|abla|earrow|eg|ot|u)\b/g, "\\n$1");

  // 2. Repair common LaTeX commands where backslash was stripped or turned into bare word:
  s = s.replace(/(^|[^\\])\bext\{/g, "$1\\text{");
  s = s.replace(/(^|[^\\])\bextbf\{/g, "$1\\textbf{");
  s = s.replace(/(^|[^\\])\brac\{/g, "$1\\frac{");
  s = s.replace(/(^|[^\\])\bsqrt\{/g, "$1\\sqrt{");

  // Clean up any double backslashes before text/frac/textbf/sqrt if created
  s = s.replace(/\\\\text\{/g, "\\text{");
  s = s.replace(/\\\\frac\{/g, "\\frac{");
  s = s.replace(/\\\\textbf\{/g, "\\textbf{");
  s = s.replace(/\\\\sqrt\{/g, "\\sqrt{");

  // Strip unsupported document-level environments that cause KaTeX parsing crashes
  s = s.replace(/\\begin\{(?:enumerate|itemize)\}/gi, "");
  s = s.replace(/\\end\{(?:enumerate|itemize)\}/gi, "");
  s = s.replace(/\\item\s*/gi, " \\\\ \\bullet \\; ");

  // Escape raw % characters (in KaTeX % is a comment that cuts off the formula)
  s = s.replace(/(?<!\\)%/g, "\\%");

  // 3. Clean up non-printable control characters and replace tabs with spaces
  s = s.replace(/[\x00-\x08\x0b\x0c\x0e-\x1f\x7f]/g, " ");
  s = s.replace(/\t+/g, " ");

  // 4. Clean up duplicate spaces inside text
  s = s.replace(/ {2,}/g, " ");

  return s.trim();
}

export function formatLatexForDisplay(rawLatex) {
  if (!rawLatex || typeof rawLatex !== "string") return "";
  let clean = repairLatexEscapes(rawLatex);
  if (/\r?\n/.test(clean) && !/\\\\/.test(clean)) {
    clean = clean.replace(/(?<!\\\\)\r?\n+/g, " \\\\ ");
  }
  return clean;
}
